// extracted by mini-css-extract-plugin
export default {"table":"Realtime_table__dg4GN","newRow":"Realtime_newRow__rw7c5","showup":"Realtime_showup__xaSpr"};